import type { FormField } from '@elfsight/widget-form-builder/widget';
import { MAX_CALCULATOR_FORMAT_FRACTION_DIGITS } from '../../../../constants';
import type {
  CalculatorField,
  DecimalSeparatorType,
  ThousandsSeparatorType
} from '../../../../types';
import { buildFieldIdForField } from './build-fieldId';

const SELECT_FIELDS = new Set(['choice', 'imageChoice', 'dropdown']);

const formatFieldOptions = (
  field: CalculatorField
): { id: string; name: string; value: number }[] => {
  if ('options' in field) {
    return field.options
      .filter(({ id }) => id !== undefined)
      .map(({ id, name, value }) => ({ id: id || '', name, value }));
  }

  return [];
};

export const prepareCalculatorFields = (
  fields: CalculatorField[],
  displayedFields: CalculatorField[],
  fieldsScope: Record<string, { value: string | string[] }>,
  thousandsSeparator?: ThousandsSeparatorType,
  decimalSeparator?: DecimalSeparatorType
): FormField[] =>
  fields
    .filter(({ type }) => type !== 'heading')
    .map((field) => {
      const isSelectableField = SELECT_FIELDS.has(field.type);
      const scopeValue = fieldsScope[field.id || '']?.value;
      const initialValueMultiple = Array.isArray(scopeValue)
        ? scopeValue
        : [scopeValue];

      const value = initialValueMultiple.join(', ');

      const isHiddenByConditional = displayedFields.every(
        (displayedField) => displayedField.id !== field.id
      );

      return {
        ...field,
        id: field?.id || '',
        fieldID: field?.fieldID || buildFieldIdForField(field),
        type: field.type,
        value: field.type.includes('choice') ? initialValueMultiple : value,
        initialValue: isSelectableField ? value : '',
        initialValueMultiple: isSelectableField
          ? initialValueMultiple
          : undefined,
        options: isSelectableField ? formatFieldOptions(field) : undefined,
        isCalculatorField: true,
        group: 'calculation-inputs',
        hidden: isHiddenByConditional,
        required: false,
        thousandsSeparator,
        decimalSeparator,
        maximumFormatFractionDigits:
          field.type === 'slider'
            ? MAX_CALCULATOR_FORMAT_FRACTION_DIGITS
            : undefined
      };
    });
